<template>
  <div class="card p-2" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th class="text-center">Title</th>
          <th class="text-center">Letter Type</th>
          <th class="text-center">Message Type</th>
          <th class="text-center">Status</th>
          <th class="text-center">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in tableItems" :key="i">
          <td class="text-center">{{ item.title }}</td>
          <td class="text-center">{{ item.note_master_name }}</td>
          <td class="text-center">{{ item.message_type }}</td>
          <td class="text-center">{{ item.status }}</td>
          <td class="text-center">
            <button class="btn btn-primary btn-sm"
                    @click="goToEdit(item)"
                    style="cursor: pointer"
            >
              <i class="fas fa-eye"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <p v-if="tableItems.length < 0" class="text-center mt-5">No data</p>
    </div>
  </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";

const props  = defineProps({
  tableItems     : Object,
});
const route  = useRoute();
const router = useRouter();

const goToEdit = (item) => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId
  }

  let query = route.query;
  query.messageTemplateId = item.id;

  router.push({
    name:  'letter-template-add',
    params: param,
    query: query
  })
}

</script>
